import styled from "styled-components";
import { theme } from "../../source/theme";


export const CartButton = styled.button`
    padding-left : 8px;
    padding-right : 8px;
    padding-bottom: 3px;
    padding-top: 3px;

    border-radius: 8px;

    border-width: 1px;
    
    box-shadow: rgba(50, 50, 93, 0.25) 0px 2px 5px -1px, ${ theme.secundary } 0px 1px 3px -1px;
    
    border-radius: 2px;
`;


export const ContainerConfirmed = styled.div`
    display: flex;
    flex-direction: column;
`;

export const ActionButton = styled.button`
    padding-left : 10px;
    padding-right : 10px;
    padding-bottom: 5px;
    padding-top: 5px;

    border-radius: 8px;

    border-width: 1px;

    box-shadow: rgba(50, 50, 93, 0.25) 0px 2px 5px -1px, ${ theme.secundary } 0px 1px 3px -1px;

    border-radius: 2px;
`;

export const ConfirmedConfirmationButton = styled.button`
    margin-bottom: 10px;

    background-color: #ff0e0e;
    color: white;

    padding-left : 10px;
    padding-right : 10px;
    padding-bottom: 5px;
    padding-top: 5px;

    border-radius: 8px;

    border-width: 1px;

    box-shadow: rgba(50, 50, 93, 0.25) 0px 2px 5px -1px, ${ theme.secundary } 0px 1px 3px -1px;

    border-radius: 2px;
`;